export default {
  SET_PARTNERS (state, partners) {
    state.partners = partners
  },
  REMOVE_RECORD (state, itemId) {
    const roleIndex = state.partners.findIndex((u) => u.id === itemId)
    state.partners.splice(roleIndex, 1)
  }
}
